/**
 * Roommatik identity for the hotel facade (roadmap #123): the corporate logo
 * asset, never redrawn or recoloured (design system foundations §2.1). Identity
 * appears once per screen, in this lockup. The light/white file swap follows the
 * theme mode via CSS; a dark call stage forces the white file with tone="dark".
 *
 * The environment badge (web/product.md §29) rides here so every screen carries
 * it on non-production builds; the check is compile-time, so the production
 * bundle statically drops it.
 *
 * Inside a kiosk's call window the kiosk is the host's own interface: the logo is
 * not shown there (the environment badge still is, on non-production builds).
 */
import logoLight from '../assets/roommatik-logo.png'
import logoWhite from '../assets/roommatik-logo-white.png'
import { embeddedInKiosk } from '../launchContext'

type BrandLockupProps = {
  /** 'light' = follow the theme mode (default); 'dark' = force white on a dark stage. */
  tone?: 'light' | 'dark'
}

const ENV_LABEL =
  import.meta.env.MODE === 'production' ? null : import.meta.env.MODE === 'staging' ? 'TEST' : 'LOCAL'

export default function BrandLockup({ tone = 'light' }: BrandLockupProps) {
  if (embeddedInKiosk) {
    return ENV_LABEL ? (
      <div className={`cf-lockup cf-lockup-${tone}`}>
        <span className="cf-env-badge">{ENV_LABEL}</span>
      </div>
    ) : null
  }
  return (
    <div className={`cf-lockup cf-lockup-${tone}`} role="img" aria-label="Roommatik">
      <img className="cf-logo cf-logo-light" src={logoLight} alt="" aria-hidden="true" />
      <img className="cf-logo cf-logo-dark" src={logoWhite} alt="" aria-hidden="true" />
      {ENV_LABEL && <span className="cf-env-badge">{ENV_LABEL}</span>}
    </div>
  )
}
